import axios from 'axios';
import {
	SET_TEMPLATE_FOLDERS,
	ADD_TEMPLATE_FOLDER,
	REMOVE_TEMPLATE_FOLDER,
	UPDATE_TEMPLATE_FOLDER,
} from './types';
import { getTemplates } from './templates';

export const getTemplateFolders = () => async (dispatch) => {
	try {
		const res = await axios.get('/api/template-folders');

		dispatch({
			type: SET_TEMPLATE_FOLDERS,
			payload: (!res.data.error && res.data.folders) || [],
		});
	} catch (err) {
		console.log('Error fetching template folders', err.message);
		dispatch({ type: SET_TEMPLATE_FOLDERS, payload: [] });
	}
};

// resolves with the created folder so callers can select it immediately
export const addTemplateFolder =
	({ title }) =>
	async (dispatch) => {
		try {
			const res = await axios.post('/api/template-folders/create', {
				title,
			});

			if (res.data.error || !res.data.folder) {
				return { error: true, message: res.data.message };
			}

			dispatch({
				type: ADD_TEMPLATE_FOLDER,
				payload: res.data.folder,
			});

			return { error: false, folder: res.data.folder };
		} catch (err) {
			console.log('Error adding template folder', err.message);
			return { error: true, message: 'Could not create the folder' };
		}
	};

export const renameTemplateFolder =
	({ _folder, title }) =>
	async (dispatch) => {
		try {
			const res = await axios.post('/api/template-folders/rename', {
				_folder,
				title,
			});

			if (res.data.error || !res.data.folder) {
				return { error: true, message: res.data.message };
			}

			dispatch({
				type: UPDATE_TEMPLATE_FOLDER,
				payload: res.data.folder,
			});

			return { error: false, folder: res.data.folder };
		} catch (err) {
			console.log('Error renaming template folder', err.message);
			return { error: true, message: 'Could not rename the folder' };
		}
	};

export const removeTemplateFolder =
	({ _folder, isEnterpriseRequested = false }) =>
	async (dispatch) => {
		try {
			const res = await axios.post('/api/template-folders/delete', {
				_folder,
			});

			if (res.data.error || !res.data._folder) {
				return { error: true, message: res.data.message };
			}

			dispatch({
				type: REMOVE_TEMPLATE_FOLDER,
				payload: res.data._folder,
			});

			// the server unfiled the folder's templates; refetch so local
			// template state picks up the cleared _folder refs
			dispatch(getTemplates(isEnterpriseRequested));

			return { error: false };
		} catch (err) {
			console.log('Error removing template folder', err.message);
			return { error: true, message: 'Could not delete the folder' };
		}
	};

export const moveTemplateToFolder =
	({ _template, _folder, isEnterpriseRequested = false }) =>
	async (dispatch) => {
		try {
			const res = await axios.post('/api/template/move-to-folder', {
				_template,
				_folder: _folder || null,
			});

			if (res.data.error) {
				return { error: true, message: res.data.message };
			}

			// templates state has no granular update case — refetch, matching
			// the established refetch-on-mutation pattern for templates
			dispatch(getTemplates(isEnterpriseRequested));

			return { error: false, template: res.data.template };
		} catch (err) {
			console.log('Error moving template to folder', err.message);
			return { error: true, message: 'Could not move the template' };
		}
	};
